import { render, staticRenderFns } from "./ModalSolicitarAlterarTransporte.vue?vue&type=template&id=0c286e40&scoped=true"
import script from "./ModalSolicitarAlterarTransporte.vue?vue&type=script&lang=js"
export * from "./ModalSolicitarAlterarTransporte.vue?vue&type=script&lang=js"
import style0 from "./ModalSolicitarAlterarTransporte.vue?vue&type=style&index=0&id=0c286e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c286e40",
  null
  
)

export default component.exports